var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"activationControl"},[_c('fas-icon',{directives:[{name:"show",rawName:"v-show",value:(!_vm.show),expression:"!show"}],staticClass:"fa",attrs:{"icon":_vm.iconOpened}}),_c('fas-icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"fa",attrs:{"icon":_vm.iconClosed}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }